import { stringify } from 'qs';
import { UiResponse } from '../CommonInterfaces';
import { ROUTES, View } from '../Routes';

const localNavigationExclusionPaths: Set<string> = new Set<string>(['/oauth2/authorize', '/pub/v1/ws_idp']);

export const extractHyperlink = (url: string): HTMLHyperlinkElementUtils => {
  const link = document.createElement('a');
  link.href = url;
  return link;
};

export const hasCurrentHost = (eventTarget: { hostname?: string; href?: string; pathname?: string }): boolean => {
  if (eventTarget.hostname) {
    return isSameHost(eventTarget.hostname) && !isExcludedPath(eventTarget.pathname);
  }
  return isSameProtocolAndHost(eventTarget.href);
};

const isSameHost = (hostname: string) => {
  return hostname === window.location.hostname;
};

export const isSameProtocolAndHost = (href: string = '') => {
  const host = `${window.location.protocol}//${window.location.host}`;
  if (href.startsWith(host)) {
    const path = href.replace(host, '');
    return !Array.from(localNavigationExclusionPaths).find((p) => path.startsWith(p));
  }
  return false;
};

export const hasModifierKey = (event: any) => {
  // justification for type any: there exist unrelated event classes defining these props
  return !!(event.ctrlKey || event.altKey || event.shiftKey || event.metaKey);
};

export const prefixWithSlash = (pathName: string): string => {
  return pathName.length && !pathName.startsWith('/') ? `/${pathName}` : pathName;
};

export const getPathByComponent = (component: string | undefined) => {
  const componentRoute = ROUTES.find((route) => {
    return route.name === component;
  });
  if (!componentRoute?.path) {
    console.error(`No path found for component ${component ?? 'No component given'}`);
    return '';
  }
  return componentRoute.path;
};

// TODO: replace usages of getPathForComponent with this to simplify forwarding query params
export const getUrlForComponent = (uiResponse: UiResponse, defaultQueryString?: string) => {
  const path = getPathForComponent(uiResponse);
  const queryString = uiResponse.component === View.LARES ? stringify(uiResponse.params, { addQueryPrefix: true }) : defaultQueryString;
  return `${path}${queryString}`;
};

export const getPathForComponent = (uiResponse: UiResponse) => {
  return getPathByComponent(uiResponse.component);
};

export const urlHasParams = (url: string | null): boolean => {
  return !!url && url.indexOf('?') !== -1;
};

const isExcludedPath = (path: string | undefined) => {
  return !!path && localNavigationExclusionPaths.has(path);
};

export const removeAndAddParams = (params: string[], paramsToAdd?: string | string[]): string => {
  const replaceValue = window.location.search
    .split('&')
    .filter((search: string) => {
      return params.every((param) => !search.includes(param));
    })
    .concat(paramsToAdd || [])
    .join('&');

  return replaceValue.startsWith('?') ? replaceValue : `?${replaceValue}`;
};
